import React from 'react';

import {
  LookupStepInfo,
  LookupStepType,
  PLUS_SIGN,
  RIGHT_ARROW,
} from 'lookup-config/LookupConfigModalConstants';

export default function LookupStepSeparatorIcon({
  index,
  lookupStepInfos,
}: {
  index: number;
  lookupStepInfos: Array<LookupStepInfo>;
}): JSX.Element {
  if (
    index < lookupStepInfos.length - 2 &&
    lookupStepInfos[index + 2].lookupStep.type === LookupStepType.CONTAINER_BY_GRID_POSITION
  ) {
    return <>{` ${PLUS_SIGN} `}</>;
  }
  return <>{` ${RIGHT_ARROW} `}</>;
}
